<template>
  <div class="security_reset_password_ask">
    <span>{{ $t('meta_title.security.reset_password_ask') }}</span>

    <div class="user_form">
      <form @submit.prevent="post" method="post">
        <div class="form-group">
          <label for="user_email" class="required">{{ $t('object.user.email') }}</label>
          <input type="email" id="user_email" name="email" class="form-control" v-model="email">
        </div>
        <input type="submit">
      </form>
    </div>
  </div>
</template>

<script>
  import toast from '@/toastr'

  export default {
    name: 'SecurityResetPasswordAsk',
    data() {
      return {
        email: '',
      }
    },
    methods: {
      post() {
        this.$http.post('user/reset_password', {
          email: this.email
        },{
          redirectOnSuccess: {name: 'Home'}
        })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Security/reset_password_ask.vue